import { render, staticRenderFns } from "./PosOrdersTable.vue?vue&type=template&id=e4c1b870&scoped=true&"
import script from "./PosOrdersTable.vue?vue&type=script&lang=js&"
export * from "./PosOrdersTable.vue?vue&type=script&lang=js&"
import style0 from "./PosOrdersTable.vue?vue&type=style&index=0&id=e4c1b870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c1b870",
  null
  
)

export default component.exports